class DataSourceUsageDto {
    public PathId: number;
    public PathName: string;
    public PathType: string;

    constructor(
        pathId: number,
        pathName: string,
        pathType: string
    ) {
        this.PathId = pathId;
        this.PathName = pathName;
        this.PathType = pathType;
    }
}

export default DataSourceUsageDto;
